// this component replicates the Confluence loading screen in the iframe as close to pixel-perfect
// as possible, so that we can transition between loading the iframe and rendering the iframe once
// it's ready as seamlessly as possible
import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { ConfluenceIcon } from '@atlaskit/logo/confluence-icon';
import { layers } from '@atlaskit/theme/constants';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Blanket = styled.div({
	zIndex: layers.blanket(),
	position: 'absolute',
	width: '100%',
	height: '100%',
	top: 0,
	left: 0,
	backgroundColor: token('elevation.surface', 'white'),
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> span': {
		height: '56px',
		margin: '181px 14px 13px 11px',
		animation: 'pulse 2s infinite',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
		'@keyframes pulse': {
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
			'0%': {
				opacity: 0.7,
			},
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
			'50%': {
				opacity: 1,
			},
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
			'100%': {
				opacity: 0.7,
			},
		},
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	position: 'relative',
	height: '100%',
	zIndex: 1, // make sure this is on top of the inner modal blanket when it is shown
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	iframe: {
		backgroundColor: token('elevation.surface', 'white'),
	}, // ensure the iframe is not transparent so we won't see the modal blanket under it even if the content is short
});

// children is always rendered, but the blanket will cover the content unless isLoading=false
export const LoadingContainer = ({
	isLoading,
	children,
}: {
	isLoading: boolean;
	children?: React.ReactNode;
}) => (
	<Container data-testid="embedded-confluence-loading-container">
		{children}
		{isLoading && (
			<Blanket>
				<ConfluenceIcon appearance="neutral" />
			</Blanket>
		)}
	</Container>
);
